import React from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import Header from '../../Header'
import Footer from '../../Footer'
import { setUIBackwardsAction, setUIForwardAction } from '../../../actions'
import { UI } from '../../../constants/ui'
import { setCargoContentAction, setCargoWeightAction } from '../../../actions/reservationChange'
import { AppState } from '../../../reducers'
import './cargoContent.less'
import { setTotalPagesCountAction } from '../../../actions/reservation'
import FooterMobile from '../../FooterMobile'
import { getMode } from '../../../hooks/mode'
import { MODE } from '../../../constants/mode'

interface ContentType {
  label: string
  id: string
}
const contentTypes: ContentType[] = [
  { id: 'content-1', label: 'EMPTY' },
  { id: 'content-2', label: 'CHEMICALS & FUEL' },
  { id: 'content-3', label: 'CONSTRUCTION MATERIALS' },
  { id: 'content-4', label: 'ELECTRONICS' },
  { id: 'content-5', label: 'FOODSTUFF' },
  { id: 'content-6', label: 'FOREST INDUSTRIES' },
  { id: 'content-7', label: 'FURNITURE & TEXTILE' },
  { id: 'content-8', label: 'GENERAL CARGO' },
  { id: 'content-9', label: 'LAUNDRY & SERVICE' },
  { id: 'content-10', label: 'LIVE ANIMALS' },
  { id: 'content-11', label: 'MACHINES & CARS' },
  { id: 'content-12', label: 'MEDICINE' },
  { id: 'content-13', label: 'METAL & STEEL' },
  { id: 'content-14', label: 'PARCEL & AIR CARGO' },
]

const WRAP_SPLITTER = '<wbr>'

const mapDispatchToProps = {
  setUIForward: setUIForwardAction,
  setUIBackwards: setUIBackwardsAction,
  setCargoContent: setCargoContentAction,
  setCargoWeight: setCargoWeightAction,
  setTotalPagesCount: setTotalPagesCountAction,
}

type DispatchProps = typeof mapDispatchToProps

const mapStateToProps = (state: AppState) => ({
  reservationChange: state.reservationChange,
})

type StateProps = ReturnType<typeof mapStateToProps>
type Props = DispatchProps & StateProps

interface CustomProps {
  setSelectedCargoContent: (item: ContentType) => void
  onButtonClick: () => void
}

type CargoContentCustomProps = CustomProps & Pick<Props, 'reservationChange' | 'setUIBackwards'>

const CargoContentMobile: React.FC<CargoContentCustomProps> = ({ setUIBackwards, reservationChange, setSelectedCargoContent, onButtonClick }) => {
  const { t } = useTranslation()
  return (
    <div className="cargo-content-mobile">
      <div className="cargo-content-mobile-wrapper">
        <div className="cargo-content-title" dangerouslySetInnerHTML={{ __html: t('cargoContentSelect') }}></div>
        <div className="content-selectors">
          {contentTypes.map((item) => (
            <button
              key={item.id}
              id={item.id}
              className={
                item.label === reservationChange.cargoContent
                  ? `content-button selected-content-button`
                  : `content-button`
              }
              onClick={() => setSelectedCargoContent(item)}
            >
              {t(item.label).split(WRAP_SPLITTER).map((item, index) => {
                return <div key={index}>{item}</div>
              })}
            </button>
          ))}
        </div>
        <div className="next-button">
          <button className="main-button-mobile" onClick={onButtonClick} disabled={!reservationChange.cargoContent}>
            {t('next')}
          </button>
        </div>
        <div className="back-button-container-selected-content">
          <button className="back-button" onClick={() => setUIBackwards(UI.CARGO_LENGTH)}>
            <div className="text-button">{'← ' + t('back')}</div>
          </button>
        </div>
      </div>
      <div className="footer-mobile-container">
        <FooterMobile showPageCount />
      </div>
    </div>
  )
}

const CargoContentDesktop: React.FC<CargoContentCustomProps> = ({ setUIBackwards, reservationChange, setSelectedCargoContent, onButtonClick }) => {
  const { t } = useTranslation()
  return (
    <>
      <Header showPageCount back={() => setUIBackwards(UI.CARGO_LENGTH)} />
      <div className="cargo-content">
        <div className="cargo-content-title" dangerouslySetInnerHTML={{ __html: t('cargoContentSelect') }}></div>
        <div className="content-selectors">
          {contentTypes.map((item) => (
            <button
              key={item.id}
              id={item.id}
              className={
                item.label === reservationChange.cargoContent
                  ? `content-button selected-content-button`
                  : `content-button`
              }
              onClick={() => setSelectedCargoContent(item)}
              dangerouslySetInnerHTML={{ __html: t(item.label) }}
            >
            </button>
          ))}
        </div>
        <div className="next-button">
          <button className="main-button" onClick={onButtonClick} disabled={!reservationChange.cargoContent}>
            {t('next')}
          </button>
        </div>
      </div>
      <Footer />
    </>
  )
}

const CargoContent: React.FC<Props> = ({
  setUIForward,
  setUIBackwards,
  setCargoContent,
  setCargoWeight,
  setTotalPagesCount,
  reservationChange,
}: Props) => {
  const mode = getMode()

  const setSelectedCargoContent = (item: ContentType) => {
    const selectedElement = contentTypes.find((contentType) => item.id === contentType.id)
    selectedElement && setCargoContent(selectedElement.label)
  }

  const onButtonClick = () => {
    if (reservationChange.cargoContent === 'EMPTY') {
      setCargoWeight(0)
      setTotalPagesCount({ ...reservationChange, cargoWeight: 0 })
      setUIForward(UI.FROM_TO)
    } else {
      setTotalPagesCount(reservationChange)
      setUIForward(UI.CARGO_WEIGHT)
    }
  }

  const customProps = { setUIBackwards, reservationChange, setSelectedCargoContent, onButtonClick }
  if (mode === MODE.MOBILE) {
    return <CargoContentMobile {...customProps} />
  } else {
    return <CargoContentDesktop {...customProps} />
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CargoContent)
